import Component, { mixins } from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import { PolarArea, mixins as chartMixins } from "vue-chartjs";
// import "chartjs-plugin-colorschemes";

@Component({
    name: "polar-area-chart",
})
export default class PolarAreaChart extends mixins(PolarArea, chartMixins.reactiveProp) {
    @Prop()
    public chartData: Chart.ChartData;

    @Prop()
    public options: Chart.ChartOptions;

    @Watch("options", { deep: true })
    public onOptionsChanged(): void {
        this.renderChart(this.chartData, this.options);
    }

    public mounted(): void {
        this.renderChart(this.chartData, this.options);
    }
}
